import { call, put } from 'redux-saga/effects'
import api from './../../../utils/api'
import actions from './../actions'

const queryReportTypes = () => call(api.getReportTypes)

function* fetchReportTypes() {
  let reportTypes
  try {
    reportTypes = yield queryReportTypes()
    yield put({ type: actions.setReportTypes, reportTypes })
  } catch (e) {
    yield put({ type: actions.failedReportTypes, error: e })
  }
}

export default fetchReportTypes



// WEBPACK FOOTER //
// ./src/store/reports/reportTypes/saga.js